import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { AppProviders } from '@/app/providers'
import { createQueryClient } from '@/app/query-client'
import { createAppRouter } from '@/app/router'
import '@/lib/i18n'
import { initTheme } from '@/lib/theme/useTheme'
import '@/styles/index.css'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('#root elemanı bulunamadı — index.html bozulmuş olabilir.')
}

// Sınıfı `index.html`'deki satır içi betik zaten yazdı; buradaki çağrı o kararı uygulamanın
// durumuna alıyor ve işletim sistemi tercihi oturum sırasında değişirse takip ediyor. Uygulama
// ömrü boyunca tek örnek olduğu için dinleyici kaldırılmıyor.
initTheme()

const queryClient = createQueryClient()
const router = createAppRouter()

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders queryClient={queryClient}>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
)
